import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';

import { configureStore } from '@reduxjs/toolkit';
import { Provider } from 'react-redux';

import * as serviceWorker from './serviceWorker';

import { apiConfig, amplifyConfig, theme } from 'config';
import reducer, { createLoggerMiddleware } from 'reducers';
import { appApi } from 'api';

import { CssBaseline, ThemeProvider, StyledEngineProvider } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import moment from 'moment';
import 'moment/locale/fr';
import App from 'App';

moment.locale('fr');

const loggerMiddleware = createLoggerMiddleware();

export const store = configureStore({
    reducer,
    middleware: getDefaultMiddleware => {
        return getDefaultMiddleware({ serializableCheck: false }).concat(
            appApi.middleware,
            loggerMiddleware
        );
    },
});

amplifyConfig.initAmplify();
apiConfig.configureAxios(store);

ReactDOM.render(
    <React.StrictMode>
        <Provider store={store}>
            <StyledEngineProvider injectFirst>
                <ThemeProvider theme={theme}>
                    <LocalizationProvider dateAdapter={AdapterMoment} adapterLocale="fr">
                        <CssBaseline />
                        <BrowserRouter>
                            <App />
                        </BrowserRouter>
                    </LocalizationProvider>
                </ThemeProvider>
            </StyledEngineProvider>
        </Provider>
    </React.StrictMode>,
    document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
